// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import Link, { LinkPresentationProps } from "@rpsc/MobiusOverrides/Link/Link";
import { XNGAGE_CUSTOM_WIDGET } from "@rpsc/XDL/constants";
import React, { FC } from "react";

const enum fields {
    linkLabel = "linkLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.linkLabel]: string;
    };
}

export interface GoBackStyles {
    linkStyles?: LinkPresentationProps;
}

export const goBackStyles: GoBackStyles = {};

export const GoBack: FC<OwnProps> = ({ fields: { linkLabel } }) => {
    const history = useHistory();

    const { homePageUrl } = useAppSelector(state => ({
        homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
    }));

    const goBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            homePageUrl && history.push(homePageUrl);
        }
    };

    const styles = goBackStyles;

    return (
        <Link {...styles.linkStyles} onClick={goBack} aria-label={linkLabel}>
            {translate(linkLabel)}
        </Link>
    );
};

const goBack: WidgetModule = {
    component: GoBack,
    definition: {
        group: XNGAGE_CUSTOM_WIDGET,
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.linkLabel,
                editorTemplate: "TextField",
                displayName: "Link Label",
                defaultValue: "Label",
            },
        ],
    },
};

export default goBack;
